export const menuItems = [
    // fill 
    {
        id: 1,
        label: "menuitems.dashboard.text",
        isTitle: true
    },
    {
        id: 2,
        label: 'menuitems.dashboard.text',
        icon: 'ri-dashboard-line',
        link: '/'
    },
    {
        id: 3,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 4,
        label: 'menuitems.services.text',
        icon: 'ri-service-fill',
        link: '/atendimentos'
    },
    {
        id: 5,
        label: 'menuitems.registers.list.schedule',
        icon: 'ri-calendar-line',
        link: '/cadastros/calendario'
    },
    {
        id: 55,
        label: 'menuitems.prontuarios.text',
        icon: 'ri-health-book-line',
        link: '/medical-records'
    },
    {
        id: 6,
        label: 'menuitems.registers.text',
        icon: 'ri-store-2-line',
        subItems: [
            {
                id: 61,
                label: 'menuitems.registers.list.approach',
                icon: 'ri-team-fill',
                link: '/cadastros/abordagem'
            },
            {
                id: 62,
                label: 'menuitems.registers.list.agreement',
                icon: 'ri-team-fill',
                link: '/cadastros/convenio'
            },
            {
                id: 63,
                label: 'menuitems.registers.list.companies',
                icon: 'ri-store-fill',
                link: '/cadastros/empresas'
            },
            {
                id: 64,
                label: 'menuitems.registers.list.register_pacients',
                icon: 'ri-team-fill',
                link: '/cadastros/pacientes'
            },
            {
                id: 65,
                label: 'menuitems.registers.list.plan-accounts',
                icon: 'ri-team-fill',
                link: '/cadastros/plano-contas'
            },
            {
                id: 66,
                label: 'menuitems.registers.list.profissionals',
                icon: 'ri-team-fill',
                link: '/cadastros/profissionais'
            },
            {
                id: 67,
                label: 'menuitems.registers.list.responsibles',
                icon: 'ri-team-fill',
                link: '/cadastros/responsibles',
                permission: 'responsable.view'
            },
            {
                id: 68,
                label: 'menuitems.registers.list.treatment',
                icon: 'ri-team-fill',
                link: '/cadastros/tratamento'
            },
        ]
    },
    {
        id: 7,
        label: 'menuitems.file.text',
        icon: 'ri-file-paper-fill',
        link: '/relatorios/ficha'
    },
    {
        id: 8,
        label: "menuitems.financial.text",
        icon: 'ri-money-dollar-box-line',
        subItems: [
            {
                id: 81,
                label: 'menuitems.financial.list.accounts-payable', // Contas a Pagar
                link: '/financeiro/contas-a-pagar',
            },
            {
                id: 82,
                label: 'menuitems.financial.list.accounts-receivable', // Contas a Receber
                link: '/financeiro/contas-a-receber',
            },
            {
                id: 83,
                label: 'menuitems.financial.list.evolution-billing',
                link: '/financeiro/faturamento-evolucoes',
                permission: 'faturamento.evolucoes.view',
            },
            {
                id: 85,
                label: 'menuitems.financial.list.nfse',
                link: '/financeiro/nfse',
                anyOf: ['nfse.preview', 'nfse.documents.view'],
            },
            {
                id: 84,
                label: 'menuitems.financial.list.validation-recurrence', // Validação de Evoluções
                // Implementar link pelo nome da rota
                link: '/atendimentos/validacao-parecer',
            },
        ]
    },
    {
        id: 9,
        label: 'menuitems.parameters.text',
        icon: 'ri-global-line',
        subItems: [
            {
                id: 91,
                label: 'menuitems.parameters.list.costcenter',
                link: '/parametros/centrocusto',
            },
            {
                id: 92,
                label: 'menuitems.parameters.list.resultcenter',
                link: '/parametros/centroresultado',
            },
            {
                id: 94,
                label: 'menuitems.parameters.list.historiesdefault',
                link: '/parametros/historicopadrao',
            },
            {
                id: 93,
                label: 'menuitems.parameters.list.paymenttypes',
                link: '/parametros/tipospagamento',
            },
            {
                id: 95,
                label: 'menuitems.parameters.list.nfse-clinics',
                link: '/parametros/nfse-clinicas',
                permission: 'nfse.config.manage',
            },
        ]
    },
    {
        id: 12,
        label: 'menuitems.processes.text',
        icon: 'ri-settings-3-line',
        subItems: [
            {
                id: 122,
                label: 'menuitems.processes.list.authorize-attendances',
                link: '/processos/autorizar-atendimentos',
            },
            {
                id: 121,
                label: 'menuitems.processes.list.authorize-reschedule',
                link: '/solicitacoes-reagendamento',
            },
            {
                id: 123,
                label: 'menuitems.processes.list.tickets-manager',
                link: '/processos/gerenciador-senhas',
            },
            {
                id: 124,
                label: 'menuitems.processes.list.sessoes-mensais',
                link: '/processos/sessoes-mensais',
            },
        ]
    },
    {
        id: 10,
        label: 'menuitems.report.text',
        icon: 'ri-file-chart-line',
        subItems: [
            {
                id: 103,
                label: 'menuitems.report.list.accounts_payable_paid',
                link: '/relatorios/contas-a-pagar'
            },
            {
                id: 104,
                label: 'menuitems.report.list.accounts_receivable_received',
                link: '/relatorios/contas-a-receber'
            },
            {
                id: 105,
                label: 'menuitems.report.list.cash_flow',
                link: '/relatorios/fluxo-caixa'
            },
            {
                id: 102,
                label: 'menuitems.report.list.invoice_issuance_report',
                link: '/relatorios/atendimentos/emissao-nfse-tabela'
            },
            {
                id: 101,
                label: 'menuitems.report.list.report_atendiment',
                link: '/relatorios/atendimentos/RepasseProfissionais'
            },
            {
                id: 106,
                label: 'menuitems.report.list.resumo_repasse_profissional',
                link: '/relatorios/resumo-repasse-profissional'
            },
        ]
    },
    {
        id: 11,
        label: 'menuitems.users.text',
        icon: 'ri-account-circle-line',
        subItems: [
            {
                id: 112,
                label: 'menuitems.users.list.changepassword',
                link: '/esqueci-senha'
            },
            {
                id: 117,
                label: 'menuitems.users.list.activateDevice',
                link: '/usuarios/ativar-dispositivo'
            },
            {
                id: 115,
                label: 'menuitems.users.list.audit',
                link: '/usuarios/auditoria'
            },
            {
                id: 111,
                label: 'menuitems.users.list.insert',
                link: '/cadastrar/usuario'
            },
            {
                id: 113,
                label: 'menuitems.users.list.list',
                link: '/listar/usuarios'
            },
            {
                id: 114,
                label: 'menuitems.users.list.permissions',
                link: '/usuarios/permissoes'
            },
            {
                id: 116,
                label: 'menuitems.users.list.userCompanyRelation',
                link: '/usuarios/empresas'
            }
        ]
    },
]